import { formatDecimals } from '@webapp/core/utils/formatDecimals'
import { useProcurifyIntl } from '@webapp/hooks'
import { useFormatPercent } from '@webapp/hooks/useFormatPercent'

export const TAX_DECIMAL_POINTS = 4

export const TAX_PRESET_DECIMAL_POINTS = 8

export const useFormatTaxPercentage = () => {
  const intl = useProcurifyIntl()
  const formatPercent = useFormatPercent({ useSystemLocale: true })

  return (percentage: string | number) => {
    const fallbackValue = intl.formatNumber(0, {
      style: 'percent',
      minimumFractionDigits: TAX_DECIMAL_POINTS,
      maximumFractionDigits: TAX_DECIMAL_POINTS,
    })

    return formatPercent(
      formatDecimals(percentage).toNumber(),
      TAX_DECIMAL_POINTS,
      TAX_DECIMAL_POINTS,
      fallbackValue
    )
  }
}
